import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { DataProvider } from './context/DataContext';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import AddStock from './pages/AddStock';
import ViewStock from './pages/ViewStock';
import SubtractStock from './pages/SubtractStock';
import StockHistory from './pages/StockHistory';
import './App.css';

function App() {
  return (
    <DataProvider>
      <Router>
        <div className="App">
          <Navbar />
          <main className="main-content">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/add-stock" element={<AddStock />} />
              <Route path="/view-stock" element={<ViewStock />} />
              <Route path="/subtract-stock" element={<SubtractStock />} />
              <Route path="/history" element={<StockHistory />} />
            </Routes>
          </main>
        </div>
      </Router>
    </DataProvider>
  );
}

export default App;